import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { Loading } from '../components/Loading';
import { ProjectCard } from '../components/ProjectCard';
import { Layout } from '../components/Layout';

export const Home: React.FC = () => {
  const navigate = useNavigate();
  const { data: projects, isLoading } = useQuery({
    queryKey: ['projects'],
    queryFn: () => api.listProjects(),
  });

  if (isLoading) {
    return (
      <Layout>
        <Loading />
      </Layout>
    );
  }

  return (
    <Layout>
      <Typography variant="h4" component="h1" gutterBottom>
        Projects
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 3 }}>
        {projects?.map((project) => (
          <ProjectCard
            key={project.id}
            project={project}
            onClick={() => navigate(`/projects/${project.id}`)}
          />
        ))}
        <ProjectCard project={null} onClick={() => navigate('/projects/new')} />
      </Box>
    </Layout>
  );
};
